import {AnyEvent, JOB_SECTION_ITEM_DELETED, JobSectionItemDeletedEvent} from '../type';

export default function jobSectionItemDeleted(payload: JobSectionItemDeletedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_ITEM_DELETED,
    payload,
  }
}